import styled from "styled-components"

const Wrap = styled.div`
    position: relative;
    width: 100%;
    height: ${props => props.type == "round" ? "16px" : "8px"};
    background-color: #e1f2ed;
    overflow: hidden;
    border-radius: ${props => props.type == "round" ? "26px" : "0"};
    
    .progress {
        background-color: #1cc391;
        border-radius: ${props => props.type == "round" ? "26px" : "0"};
        height: 100%;
    }
`;

export default function ProgressBar({value=0, type="round"}) {
    return (
        <Wrap className="progress-wrap" type={type}>
            <div className="progress" style={{ width: value + "%" }}></div>
        </Wrap>
    )
}